import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Footer = ({ language }) => {
  const currentYear = new Date()?.getFullYear();

  const content = {
    en: {
      company: "Company",
      quickLinks: "Quick Links",
      contact: "Contact",
      links: {
        about: "About Us",
        beans: "Browse Beans",
        suppliers: "Suppliers",
        map: "Farm Map",
        contact: "Contact"
      },
      contactInfo: {
        email: "info@africcoffee.com",
        phone: "+8619706820472",
        address: "Deqing County, China"
      },
      copyright: `© ${currentYear} WGIH. All rights reserved.`,
      tagline: "Connecting Africa\'s finest coffee to the world"
    },
    zh: {
      company: "公司",
      quickLinks: "快速链接",
      contact: "联系方式",
      links: {
        about: "关于我们",
        beans: "浏览咖啡豆",
        suppliers: "供应商",
        map: "农场地图",
        contact: "联系我们"
      },
      contactInfo: {
        email: "info@africcoffee.com",
        phone: "+8619706820472",
        address: "中国德清县"
      },
      copyright: `© ${currentYear} WGIH. 保留所有权利。`,
      tagline: "连接非洲最优质的咖啡与世界"
    }
  };

  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-7xl mx-auto px-4 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name="Coffee" size={24} color="var(--color-primary)" />
              </div>
              <span className="text-xl font-heading font-semibold text-foreground">Africoffee</span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {content?.[language]?.tagline}
            </p>
          </div>

          <div>
            <h3 className="text-base font-heading font-semibold text-foreground mb-4">
              {content?.[language]?.quickLinks}
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about-us" className="text-sm text-muted-foreground hover:text-primary transition-smooth no-underline">
                  {content?.[language]?.links?.about}
                </Link>
              </li>
              <li>
                <Link to="/browse-beans" className="text-sm text-muted-foreground hover:text-primary transition-smooth no-underline">
                  {content?.[language]?.links?.beans}
                </Link>
              </li>
              <li>
                <Link to="/suppliers" className="text-sm text-muted-foreground hover:text-primary transition-smooth no-underline">
                  {content?.[language]?.links?.suppliers}
                </Link>
              </li>
              <li>
                <Link to="/interactive-farm-map" className="text-sm text-muted-foreground hover:text-primary transition-smooth no-underline">
                  {content?.[language]?.links?.map}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-heading font-semibold text-foreground mb-4">
              {content?.[language]?.contact}
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Icon name="Mail" size={16} className="mt-0.5 flex-shrink-0" color="var(--color-primary)" />
                <span className="text-sm text-muted-foreground">{content?.[language]?.contactInfo?.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <Icon name="Phone" size={16} className="mt-0.5 flex-shrink-0" color="var(--color-primary)" />
                <span className="text-sm text-muted-foreground">{content?.[language]?.contactInfo?.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <Icon name="MapPin" size={16} className="mt-0.5 flex-shrink-0" color="var(--color-primary)" />
                <span className="text-sm text-muted-foreground">{content?.[language]?.contactInfo?.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border text-center">
          <p className="text-sm text-muted-foreground">
            {content?.[language]?.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;